import { Scanner } from '@yudiel/react-qr-scanner'
import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { guestCheckInSchema } from '../../../validation/validate'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import {
  useCheckInTicketMutation,
  useValidateTicketCodeMutation,
} from '../../../redux-toolkits/events/events.slice'

export const EventGuestsCheckInModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
  eventId: string
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
  eventId,
}) => {
  const [
    validateTicketCode,
    { isLoading: validatingCode, data: ticketValidationData },
  ] = useValidateTicketCodeMutation()

  const [checkIn, { isLoading: checkingIn }] = useCheckInTicketMutation()

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
    setFieldError,
  } = useFormik({
    initialValues: {
      ticketCode: '',
      step: 1,
    },
    validationSchema: guestCheckInSchema,
    onSubmit: async (values) => {
      if (values.step === 1) {
        const resp = await validateTicketCode({
          ticketCode: values.ticketCode,
        })

        if (resp.data?.data.valid) {
          setFieldValue('step', 2)
        } else {
          setFieldError('ticketCode', resp.data?.data.reason)
        }
      } else {
        const resp = await checkIn({
          eventId: eventId,
          ticketCode: values.ticketCode,
        })

        if (resp.data?.success) {
          resetForm()
          onSuccessCallback()
        }
      }
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={'Guest Check In'}
      childrenClassName="md:!max-w-[420px]"
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        {values.step === 2 ? (
          <div className="border rounded-lg">
            {[
              {
                title: 'Customer Name',
                value: ticketValidationData?.data.ticket.customerName,
              },
              {
                title: 'Ticket Tier',
                value: ticketValidationData?.data.ticket.tierName,
              },
              {
                title: 'Event',
                value: ticketValidationData?.data.event.name,
              },
            ].map((it, idx) => {
              return (
                <div
                  className="px-4 border-b last:border-b-0 py-4 flex items-center justify-between text-sm"
                  key={`data-${idx}`}
                >
                  <p className="text-sec-black">{it.title}:</p>

                  <p className="font-medium">{it.value}</p>
                </div>
              )
            })}
          </div>
        ) : (
          <>
            <Scanner
              onScan={(result) => {
                const firstQrCode = result.find((r) => r.format === 'qr_code')

                if (firstQrCode) {
                  setFieldValue('ticketCode', firstQrCode.rawValue)
                }
              }}
              onError={(error) => console.log(error)}
              constraints={{
                facingMode: 'environment', // Use rear camera
                aspectRatio: 1,
              }}
              components={{
                onOff: true, // Show camera on/off button
                torch: true,
                zoom: true,
                finder: false, // Show finder overlay
              }}
              sound={true}
              classNames={{
                video: '!rounded-xl !border-black !border-[2px]',
              }}
              formats={['qr_code']}
            />

            <TextInput
              type="text"
              name="ticketCode"
              placeholder="Enter ticket code or scan QR code"
              value={values.ticketCode}
              onBlur={handleBlur}
              onChange={handleChange}
              errors={
                errors.ticketCode && touched.ticketCode ? errors.ticketCode : ''
              }
              hasIcon={false}
            />
          </>
        )}

        <Button
          label={values.step === 1 ? 'Validate' : 'Check In'}
          type="submit"
          className="mt-10"
          disabled={!isValid || validatingCode || checkingIn}
          loading={validatingCode || checkingIn}
          primary
        />

        {values.step === 2 ? (
          <Button
            label={'Cancel'}
            type="button"
            className=""
            disabled={false}
            loading={false}
            primary={false}
            variant="plain"
            onClick={() => {
              resetForm()
            }}
          />
        ) : undefined}
      </form>
    </ModalComponent>
  )
}
